<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">
                Dashboard
            </router-link>
            <router-link to="/school/timetable-management/timetable" class="text-white">
                <i class="fa fa-ellipsis-v px-2"></i>TimeTable & Calendar
            </router-link>
            <router-link to="/school/timetable-management/timetable-view" class="text-white">
                <i class="fa fa-ellipsis-v px-2"></i>TimeTable
            </router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>Time Table Break
            </span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <card header-classes="bg-transparent">
                <div>
                    <modal :show.sync="modals.TimeTableBreakModal" modal-classes="modal-dialog-centered modal-md">
                        <div class="card bg-secondary border-0 mb-0">
                            <div class="card-body">
                                <PageSpinner :onloader="onloader" />
                                <div class="form-horizontal">
                                    <form role="form">
                                        <div class="card">
                                            <h5 class="card-header">Time Table Break Setup</h5>
                                            <div class="card-body">
                                                <div class="form-group">
                                                    <label>Time Slot Period</label>
                                                    <select v-model="TimeTableTimeSlotIdVal" class="form-control">
                                                        <option value=""></option>
                                                        <option v-for="item in TimeTableBreakTimeSlots"
                                                            :key="item.timeTableTimeSlotId"
                                                            v-bind:value="item.timeTableTimeSlotId">
                                                            {{ item.slotPeriod }} From {{ item.timeFrom }} - To {{
                                                                item.timeEnd
                                                            }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>Break Name</label>
                                                    <input v-model="TimeTableBreakNameVal" class="form-control"
                                                        placeholder="Break Name" />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <template slot="footer">
                            <base-button type="default" @click="modals.TimeTableBreakModal = false">Cancel
                            </base-button>
                            <base-button type="success" @click.prevent="SubmitData()">Submit
                            </base-button>
                        </template>
                    </modal>
                    <div class="card">
                        <div class="card-body">
                            <div class="justify-content-end form-inline my-3">
                                <router-link to="/school/timetable-management/timetable-view"
                                    class="btn btn-secondary mr-2">
                                    <i class="fa fa-arrow-left-long"></i> Back to TimeTable
                                </router-link>
                                <button type="button" @click.prevent="OpenTimeTableBreak" class="btn btn-default">
                                    <i class="fa fa-plus"></i>Add New
                                </button>
                                <base-input class="input-group-alternative" placeholder="Search here..."
                                    addon-left-icon="fa fa-search" v-model="searchval">
                                </base-input>
                            </div>
                            <list-skeleton v-if="!TimeTableBreaks" :rows="3" />
                            <div v-else>
                                <table class="table table-borderless table-hover">
                                    <thead>
                                        <tr>
                                            <th>Time Slot Period</th>
                                            <th>Break Name</th>
                                            <th>From</th>
                                            <th>To</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in searchedResultQuery" :key="item.timeTableBreakId">
                                            <td>{{ item.slotPeriod }}</td>
                                            <td>{{ item.timeTableBreakName }}</td>
                                            <td>{{ item.timeFrom }}</td>
                                            <td>{{ item.timeEnd }}</td>
                                            <td> <button class="btn btn-secondary btn-sm my-2"
                                                    v-on:click="editTimeTableBreak(item)">
                                                    <i class="fa fa-edit"></i>
                                                </button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner"
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin"
export default {
    name: "TimeTableBreak",
    components: {
        PageSpinner
    },
    mixins: [CheckStaffUser, Alert],
    data() {
        return {
            accessDetails: null,
            TimeTableIdVal: localStorage.getItem("TimeTableId") || "",
            TimeTableBreakIdVal: 0,
            TimeTableBreakNameVal: "",
            TimeTableTimeSlotIdVal: 0,
            TimeTableBreaks: null,
            TimeTableBreakTimeSlots: null,
            searchval: "",
            onloader: "none",
            IsModified: false,
            modals: {
                TimeTableBreakModal: false
            }
        };
    },
    computed: {
        searchedResultQuery() {
            if (this.searchval) {
                return this.TimeTableBreaks.filter((item) => {
                    return this.searchval
                        .toLowerCase()
                        .split(" ")
                        .every(
                            (v) =>
                                item.timeTableBreakName.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.TimeTableBreaks;
            }
        },
    },
    methods: {
        OpenTimeTableBreak() {
            this.TimeTableBreakNameVal = "";
            this.TimeTableTimeSlotIdVal = 0;
            this.IsModified = false;
            this.modals.TimeTableBreakModal = true;
        },
        editTimeTableBreak(item) {
            this.IsModified = true;
            this.TimeTableBreakIdVal = item.timeTableBreakId;
            this.TimeTableBreakNameVal = item.timeTableBreakName;
            this.TimeTableTimeSlotIdVal = item.timeTableTimeSlotId;
            this.modals.TimeTableBreakModal = true;
        },
        // validate fields for TimeTableBreak form
        validateTimeTableBreak() {
            const errors = [];
            if (!this.TimeTableBreakNameVal || !String(this.TimeTableBreakNameVal).trim()) {
                errors.push("Break name is required");
            }
            if (!this.TimeTableTimeSlotIdVal || Number(this.TimeTableTimeSlotIdVal) <= 0) {
                errors.push("Please select a time slot for the break");
            }
            return errors;
        },
        SubmitData() {
            // run validation
            const errors = this.validateTimeTableBreak();
            if (errors.length) {
                this.ShowAlertError(errors.join(" | "), "");
                return;
            }

            let TimeTableBreakName = this.TimeTableBreakNameVal;
            let TimeTableTimeSlotId = Number(this.TimeTableTimeSlotIdVal);
            let TimeTableBreakId = this.TimeTableBreakIdVal;
            let TimeTableId = this.TimeTableIdVal;
            this.onloader = "flex";

            const userdata = this.IsModified
                ? { TimeTableId, TimeTableBreakName, TimeTableTimeSlotId, TimeTableBreakId }
                : { TimeTableId, TimeTableBreakName, TimeTableTimeSlotId };

            const operationVal = this.IsModified
                ? "TimeTable/UpdateTimeTableBreak"
                : "TimeTable/CreateTimeTableBreak";

            this.$store
                .dispatch(operationVal, userdata)
                .then((resp) => {
                    this.onloader = "none";
                    if (resp.responseCode == "00") {
                        this.GetTimeTableBreaks();
                        this.modals.TimeTableBreakModal = false;
                        this.IsModified = false;
                        this.TimeTableBreakIdVal = 0;
                        this.TimeTableBreakNameVal = "";
                        this.TimeTableTimeSlotIdVal = 0;
                        this.ShowAlertSuccess("Submitted Successfully", "");
                    } else {
                        this.ShowAlertError(resp.responseMessage, "");
                    }
                })
                .catch((err) => {
                    this.onloader = "none";
                    const msg = err && err.response && err.response.data ? err.response.data : (err && err.message) || "Error";
                    this.ShowAlertError(msg, "");
                });
        },
        GetTimeTableBreaks() {
            this.onloader = "flex";
            let TimeTableId = this.TimeTableIdVal;
            this.$store
                .dispatch("TimeTable/GetTimeTableBreaks",TimeTableId)
                .then((resp) => {
                    if (resp.responseCode == "00") {
                        this.TimeTableBreaks = resp.data;
                    }
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, "");
                });
        },
        GetTimeTableTimeSlotsForBreak() {
            this.onloader = "flex";
            let TimeTableId = this.TimeTableIdVal;
            this.$store
                .dispatch("TimeTable/GetTimeTableTimeSlotsForBreak",TimeTableId)
                .then((resp) => {
                    if (resp.responseCode == "00") {
                        this.TimeTableBreakTimeSlots = resp.data;
                        this.onloader = "none";
                    }
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, "");
                });
        },
    },
    mounted() {
        this.GetTimeTableBreaks();
        this.GetTimeTableTimeSlotsForBreak();
    },
};
</script>
